import React, {createContext, useReducer} from 'react';
import DatabaseReducer from './DatabaseReducer';

//the initial state of the data
export const initialState = {
    departments: [],
    departments_reload:false,
    employees:[],
    employees_reload:false,
    customers:[],
    customers_reload:false,
    control_records:[],
    error_types:[],
    protocol_types:[],
    root_causes:[],
    groups:[],
    preventions:[],
    suppliers:[],
    offenders:[],
    priority_departments: [],
    priority_departments_employees: null,
    priority_departments_reload: false,
    priorities: [],
    priorities_reload:false,
    error_records:[],
    error_records_int:[],
    error_records_ext:[],
    error_records_rek:[],
    error_records_reload:false,
    documentation:[],
    self_control:[],
    measurement_protocol:[],
    ndt_protocol:[],
    annealing_protocol:[],
    measure_complexities:[],
    users:[],
    users_reload:false,
    roles:[],
    roles_reload:false,
    tabs:[{value: `1`,label: "HomePage",mask:'home001'},{value: `2`,label: "ProfilePage",mask:'prfl001'}],
    panels:[{value: `1`,child: "HomePage"},{value: `2`,child: "ProfilePage"}],
    tabIndex: 3,
    selectedTab: '1',
    selectedMask: 'home001',
    favorites: [],
    fast_view: [],
    user_mask_filters: [],
    standard_mask_filters: [],
    last_used: [],
    user:null,
    painting_intervals:[],
    painting_intervals_reload:false,
    painting_conditions:[],
    painting_conditions_reload:false,
    painting_time_conditions:[],
    painting_employee_conditions:[],
    weather:[],
    gauges:[],
    gauges_reload:false,
    gauge_calibrations:[],
    gauge_calibrations_reload:false,
    calibration_companies:[],
    calibration_companies_reload:false,
    calibration_company_certificates:[],
    calibration_company_certificates_reload:false,
    notifications:[],
    chosen_notifications:null,
    summary_emails_otk:[],
    summary_emails_painting:[],
    summary_emails_calibration:[],
    summary_emails_training:[],
    support_tickets: [],
    support_tickets_open_count: 0,
    training_companies:[],
    training_company_contacts:[],
    // training_types, training_cards, training_employees, training_templates, company_contacts – už sa nenačítavajú pri logine, komponenty načítavajú lokálne / z API
    training_company_certificates:[],
    training_invitation_templates:[],
    training_invitation_templates_loaded: false,
    training_invitations:[],
    service_levels: [],
    service_states: [],
    service_tasks: [],
    service_all_tasks: [],
    maintenance_service_tasks: [],
    task_templates: [],
    service_user_settings: [],
    crm_levels: [],
    crm_level_user_settings: [],
    crm_states: [],
    crm_steps: [],
    crm_traders: [],
    machines: [],
    machine_types: [],
    maintenance_types: [],
    business_partners: [],
    lecturers: [],
    companies: [],
    company_certificates: [],
    otk_companies:[],
    otk_company_certificates:[],
    checklist_templates:[],
    checklist_templates_loaded: false,
    checklist_template_records:[],
    checklist_holidays:[],
    checklist_records:[],
    checklist_state_records:[],
    checklist_all_records:[],
    maintenance_company_certificates:[],
    company_statistics:[],
    maintenance_companies:[],
    company_contacts: [], // plní sa z load_company_contacts (maintenance, training CompanyContactAdd); training stránky načítavajú svoje lokálne
    maintenance_company_contacts: [],
    module_settings:[],
    /** Z /api/auth/startRequest – podmnožina company_settings pre tlač (8D, …) */
    company_settings_print: null,
    /** Jednotný branding kontrakt pre navbar/tlač/mobil */
    branding: null,
    serviceTaskUpdatedInDetail: null,
    support_ticket_updated_in_detail: null,
    lastTaskViewedUpdate: null,
    lastCrmTicketViewedUpdate: null,
    lastTicketViewedUpdate: null,
    lastRecordViewedUpdate: null,
    refreshCalibrationStateList: 0,
    refreshGaugeList: 0,
    refreshGaugeCalibrationList: 0,
    refreshSummaryEmailsMaintenanceList: 0,
}
    
/** Aktuálny stav a dispatch pre utilitu resetTabulatorMask (mimo React stromu). */
export const databaseStoreRef = { current: { state: initialState, dispatch: () => {} } };

const DatabaseStore=({children})=>{

    const [state,dispatch] = useReducer(DatabaseReducer,initialState);
    databaseStoreRef.current = { state, dispatch };

    return (
        /* providing global state to all children */
        <DatabaseContext.Provider value={[state,dispatch]}>
            {children}
        </DatabaseContext.Provider>
    );
}

export const DatabaseContext = createContext(initialState);

export default DatabaseStore;